import { useEffect,useState } from "react";
import { useTranslation } from "react-i18next"
import { PressReviewService } from "../../services/pressReviewService";
import { ArtworkGallery } from "../commons/artwork-gallery/artwork-gallery";
import { LoaderSpinner } from "../commons/loader-spinner/loader-spinner";
import { SEO } from "../commons/seo/seo";

export function PressReview(){
    const {t} = useTranslation();
    const[ reviews,setPressReviews]=useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(()=>{
        setLoading(true);
        PressReviewService().getReviews().then(
            (response:any)=>{
                setPressReviews(response.data);
            }
        ).catch((error:any) => {
            console.error('Error fetching data:', error);
        }).finally(()=>{
            setLoading(false);
        })
    },[])

    return(
        <>
            <div className="press-review-container page-container">
                <SEO
                title="Revue de presse — Les Toiles de la Juine"
                description="Retrouvez les articles, publications et mentions consacrés aux Toiles de la Juine et à l’exposition."
                />
                {loading ? (
                <LoaderSpinner visible={true} />
                ) : (
                <div>
                    <div className="section-container">
                        <h1 className="page-title">{t('press_review.label')}</h1>
                    </div>
                    <div>
                        <ArtworkGallery list={reviews} withCaption={false}/>
                    </div>
                </div>
                )}
            </div>
        </>
    )
}
